// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1151":"d33412e6","3311":"0771a91a","4552":"faa5f0e5","6436":"14bd609b","8788":"d33412e6"}[chunkId] + ".chunk.css";
};